import React from "react";
import ComponentTemplateLibrary from "../../../../components/component-templates-library/ComponentTemplateLibrary";
import { TemplateSidebarProvider } from "../../../../contexts/TemplateSidebarContext";
import { EnableColorsContext } from "../../../../hooks/useEnableColors";
import { ComponentTemplateDialogProvider } from "../../../../contexts/TemplateDialogContext";

export const CoachTemplateLibraryList = () => {
  return (
    <TemplateSidebarProvider>
      <EnableColorsContext.Provider value={true}>
        <ComponentTemplateDialogProvider>
          <ComponentTemplateLibrary />
        </ComponentTemplateDialogProvider>
      </EnableColorsContext.Provider>
    </TemplateSidebarProvider>
  );
};
